// extracted by mini-css-extract-plugin
module.exports = {"btnDel":"BtnDel_btnDel__IkyFR","iconDelete":"BtnDel_iconDelete__1F4_5"};